<script lang="ts">
  import { Wrapper, Heading } from './components';
  import type { UseFormattedProps } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;

  $: items = properties.items as unknown as UseFormattedProps['teamMembers'];
</script>

<Wrapper background="var(--vlt-lp-background)">
  <div class="staff">
    <div class="staff__title">
      <Heading
        type={'h2'}
        css={'margin-top:20px;margin-bottom:10px;text-align:center'}
      >
        {properties.heading}
      </Heading>
      <p class="staff__subtitle">{@html properties.subHeading}</p>
    </div>

    <ul class="staff__cards-list">
      {#each items as teamMember}
        <li class="staff-card">
          <div class="staff-card__info">
            <div class="staff-card__avatar">
              {#if teamMember.image}
                <img src={teamMember.image} alt={teamMember.name} />
              {:else}
                <img
                  src="https://voolt-template-asset.s3.amazonaws.com/sections/staff-placeholder.png"
                  alt={teamMember.name}
                />
              {/if}
            </div>

            <p class="staff-card__name">{teamMember.name}</p>
            <p class="staff-card__position">{teamMember.role}</p>
          </div>

          <div class="staff-card__description">
            {@html teamMember.description}
          </div>
        </li>
      {/each}
    </ul>
  </div>
</Wrapper>

<style>
  .staff {
    max-width: 1136px;
    margin: 0 auto;
    padding: 0 15px;
    color: var(--vlt-lp-background-text);
  }

  .staff__title {
    margin-bottom: 10px;
  }

  .staff__subtitle {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    letter-spacing: -0.01em;
    color: var(--vlt-lp-background-text);
    margin: 40px 0;
  }

  .staff__cards-list {
    display: flex;
    flex-direction: column;
    row-gap: 20px;

    padding: 0;
    margin: 0;
  }

  .staff-card {
    width: 100%;
    height: 410px;
    padding: 30px 24px;

    background: #ffffff;
    border: 1px solid #f3f4f6;
    box-shadow:
      0 4px 8px -2px rgba(16, 24, 40, 0.1),
      0px 2px 4px -2px rgba(16, 24, 40, 0.06);
    border-radius: 8px;
    word-break: break-word;

    box-sizing: border-box;
    list-style: none;
  }

  .staff-card p {
    margin: 0;
  }

  .staff-card__info {
    display: flex;
    flex-direction: column;
    align-items: center;
    column-gap: 16px;

    margin-bottom: 18px;
  }

  .staff-card__avatar {
    position: relative;
    padding-top: 80px;
    width: 100%;
    max-width: 80px;
    overflow: hidden;
    border-radius: 40px;

    margin-bottom: 20px;
  }

  .staff-card__avatar img {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    object-fit: cover;
  }

  .staff-card__name,
  .staff-card__position,
  .staff-card__description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .staff-card__name {
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    -webkit-line-clamp: 2;
    text-align: center;

    color: #0e0f11;
  }

  .staff-card__position {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    -webkit-line-clamp: 2;

    color: #787e87;
  }

  .staff-card__description {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #0e0f11;
    text-align: center;

    -webkit-line-clamp: 5;
  }

  @media screen and (min-width: 768px) {
    .staff__subtitle {
      font-size: 18px;
      line-height: 30px;
      margin: 30px 0 40px;
    }

    .staff__cards-list {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      gap: 20px 28px;

      padding: 0;
      margin: 0;
    }

    .staff-card {
      width: calc(50% - 15px);
    }
  }

  @media screen and (min-width: 1024px) {
    .staff-card__name {
      font-size: 24px;
    }

    .staff-card {
      width: calc(33% - 16px);
      max-width: 360px;
    }
  }
</style>
